import React from "react";
import PropTypes from "prop-types";
import { BreadcrumbsProvider } from "react-breadcrumbs-dynamic";

const OSSBreadcrumbsProvider = ({ children }) => (
  <BreadcrumbsProvider>{children}</BreadcrumbsProvider>
);

OSSBreadcrumbsProvider.propTypes = {
  children: PropTypes.node
};

export default OSSBreadcrumbsProvider;
